export const method = 'get';

export default schema => {
    return schema.users.find(1);
};
